export default __webpack_public_path__ + "static/media/Animals-21.f50bd1c0.png";